// extracted by mini-css-extract-plugin
export var header = "_tm-1";
export var maskBottom = "_tm-6";
export var maskMiddle = "_tm-7";
export var maskTop = "_tm-5";
export var root = "_tm-0";
export var scrollDownButton = "_tm-3";
export var scrollDownButtonHidden = "_tm-4";
export var viewport = "_tm-2";